export default __webpack_public_path__ + "static/media/food.7fc7857c.jpg";